var render = function render(){var _vm=this,_c=_vm._self._c;return _c('el-dialog',{attrs:{"visible":_vm.visible,"title":"推荐商品","close-on-click-modal":false,"close-on-press-escape":false,"before-close":_vm.onCancel,"width":"800px"},on:{"update:visible":function($event){_vm.visible=$event}}},[_c('Table',{ref:"table",attrs:{"tableConfig":_vm.tableConfig},on:{"checked":_vm.checked}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }